<template>
    <sp-form
        class="mobile-general-form-mobile-captcha"
        :class="`uuid-${config.uuid}`"
        ref="elForm"
        v-show="!props.hide"
        :model="formModel"
        :rules="rules"
        @submit.native.prevent
    >
        <sp-form-item prop="captchaValue">
            <sharp-comp-captcha
                :label="i18nLabel"
                :is-required="props.required"
                v-model.trim="formModel.captchaValue"
                :maxlength="+props.maxlength"
                :placeholder="i18n(props.placeholder)"
                :button-text="buttonText"
                :cooldown="!countdownTime"
                :disabled="selfDisabled"
                @blur="onBlur"
                @sent="onSend"
            ></sharp-comp-captcha>
        </sp-form-item>
    </sp-form>
</template>
<script>
import { Form, FormItem } from '@ks/sharp-ui';
import SharpCompCaptcha from '@ks/sharp-comp-form-captcha';
import '@ks/sharp-comp-form-captcha/lib/themes/default/index.css';
import { composeUrlWithParam } from '../../utils';
import ComponentBase from '../component-base';
import { $http } from '../component-base/xhr';
import { component } from './props';
export default {
    name: component,
    components: {
        SpForm: Form,
        SpFormItem: FormItem,
        SharpCompCaptcha,
    },
    extends: ComponentBase,
    data() {
        return {
            isRequesting: false,
            countdownTime: 0,
            formModel: {
                captchaValue: '',
            },
        };
    },
    computed: {
        rules() {
            const rules = [];
            // 正则表达式
            if (this.props.pattern) {
                try {
                    const regExp = new RegExp(this.props.pattern);
                    rules.push({
                        pattern: regExp,
                        message: this.i18n(this.props.errPattern, this.i18nLabel)
                            || `${this.i18nLabel}格式不合规`,
                    });
                } catch (e) {
                    this.warn(e);
                }
            }
            return {
                captchaValue: this.composeRules(this.props, { otherRules: rules }),
            };
        },
        buttonText() {
            if (this.countdownTime > 0) {
                return `${this.countdownTime}${this.i18n(this.props.countdownText)}`;
            }
            return this.i18n(this.props.buttonText);
        },
        extraParams() {
            return this.globalModel.globalParams || {
                ...this.$route.params,
                ...this.$route.query,
            };
        },
    },
    beforeDestroy() {
        this.destroyTimer();
    },
    methods: {
        startTimer() {
            this.countdownTime = Math.round(+this.props.countdownSecond) || 60;
            this._timer = setInterval(() => {
                this.countdownTime--;

                if (this.countdownTime === 0) {
                    clearInterval(this._timer);
                    this._timer = null;
                    return;
                }
            }, 1000);
        },
        destroyTimer() {
            if (this._timer) {
                clearInterval(this._timer);
                this._timer = null;
            }
        },
        async doSendRequest(mobile) {
            // 这个组件的请求比较特殊，不需要保存结果，干脆就封进组件里
            const payload = {
                ...this.props.extraPayload,
                countryCode: this.props.countryCode || '+86',
                [this.props.mobileKey || 'mobile']: mobile,
            };
            const url = composeUrlWithParam(this.props.sendUrl, {
                ...this.extraParams,
                ...this.globalModel.formData,
            });
            this.isRequesting = true;
            try {
                if (typeof this.formRoot.handleApiAction === 'function') {
                    await this.formRoot.handleApiAction({
                        method: 'post',
                        url,
                        payload,
                    });
                } else {
                    // 这里其实应该判断result是否为1，不过这已经是业务或者说是项目逻辑了
                    // 所以推荐用handleApiAction去自己抛错误
                    await $http.post(url, payload);
                }
                // 请求成功，启动计时器
                this.startTimer();
            } catch (e) {
                // this.validateFailureHandler(e.message);
                this.toastAndLog(e.message);
            } finally {
                this.isRequesting = false;
            }
        },
        async onSend() {
            if (this.isRequesting) {
                return;
            }
            // 获取对应的手机号组件值
            const mobile = this.globalModel.getValueById(this.props.relatedMobile, 'value');
            if (!mobile) {
                // this.validateFailureHandler(
                //     this.i18n(this.props.errMobile)
                //     || '请检查手机号'
                // );
                this.toastAndLog(this.i18n(this.props.errMobile) || '请检查手机号');
                return;
            }
            // 校验对应的手机号
            const mobileComponent = this.globalModel.componentModels[this.props.relatedMobile];
            const mobileValid = await mobileComponent.validate();
            if (!mobileValid) {
                // 调用对方组件的校验会走对方的错误显示，这里直接退出
                return;
            }
            // 手机号合法，发送请求
            this.doSendRequest(mobile);
        },
        onBlur($event) {
            // trim其实已经在v-model指令里做了
            this.onValueChange($event);
            this.$emit('user-input');
        },
        onValueChange() {
            const res = this.setSelfFormDataValue(this.formModel.captchaValue);
            if (res) {
                // 数据修改成功，抛出change事件，触发依赖
                this.$emit('change');
            }
        },
        /**
         * 以下是组件公共方法的实现
         */
        dataChangeHandler() {
            const newValue = this.getSelfFormDataValue();
            if (typeof newValue === 'undefined') {
                // 默认值逻辑
                this.formModel.captchaValue = '';
                this.onValueChange('');
                // this.validate();
                return;
            }

            if (this.formModel.captchaValue !== newValue) {
                this.formModel.captchaValue = newValue;
                // 数据被动修改同样抛出change事件
                this.$emit('change');
                // this.validate();
            }
        },
        async validate() {
            if (this.skipValidate()) {
                return true;
            }
            const promise = new Promise((resolve, reject) => {
                this.$refs.elForm.validate((valid, invalidFields) => {
                    valid ? resolve(valid) : reject(invalidFields);
                });
            });
            try {
                return await promise;
            } catch (e) {
                this.validateFailureHandler(e.captchaValue[0].message);
                return false;
            }
        },
        clearValidate() {
            this.$refs.elForm.clearValidate();
        },
    },
};
</script>
<style lang="less" scoped>
/deep/ .spc-form-captcha-button {
    // FIXME sharpUI升级时需要把颜色覆盖去掉
    color: #FF8000;
}
</style>
